import { createRouter, createWebHistory } from 'vue-router'
import DashboardView from './views/DashboardView.vue'
import ContentView from './views/ContentView.vue'
import MigrationView from './views/MigrationView.vue'

export default createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'dashboard', component: DashboardView },
    { path: '/content', name: 'content', component: ContentView },
    { path: '/migration', name: 'migration', component: MigrationView }
  ]
})

